import script from "./TransactionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&setup=true&lang=js"

import "./TransactionInfo.vue?vue&type=style&index=0&id=f8831294&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8831294"]])

export default __exports__